import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_GESCON_SEF_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodos(filtro) {
        return axiosJwt
            .get(
                `${api}/gescon/financeiro/pagamentos?situacao=${filtro.situacao}&status=${filtro.status}&dataInicial=${filtro.dataInicial}&dataFinal=${filtro.dataFinal}&classificacao=${filtro.classificacao}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorId(pagamentoId) {
        return axiosJwt
            .get(`${api}/gescon/financeiro/pagamentos/${pagamentoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPagamentoAnexo(pagamentoAnexoId) {
        return axiosJwt
            .get(
                `${api}/gescon/financeiro/pagamentos/anexos/${pagamentoAnexoId}`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    aprovarReprovarPagamento(aprovaReprovaPagamentoDto) {
        return axiosJwt
            .post(
                `${api}/gescon/financeiro/pagamentos/${aprovaReprovaPagamentoDto.pagamentoId}/aprovar`,
                aprovaReprovaPagamentoDto
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarObservacoes(pagamentoObservacoesDto) {
        return axiosJwt
            .post(
                `${api}/gescon/financeiro/pagamentos/${pagamentoObservacoesDto.pagamentoId}/atualizarobservacoes`,
                pagamentoObservacoesDto
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    exportar(id) {
        let url = `${api}/gescon/financeiro/pagamentos/${id}/exportar`
        return axiosJwt
            .get(url, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterHistorico(pagamentoId) {
        return axiosJwt
            .get(`${api}/gescon/financeiro/pagamentos/${pagamentoId}/historico`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoAprovadores(idComprometimento) {
        let url = `${api}/gescon/financeiro/pagamentos/comprometimentos/${idComprometimento}/aprovadores`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoAnexos(idComprometimento) {
        let url = `${api}/gescon/financeiro/pagamentos/comprometimentos/${idComprometimento}/anexos`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoAnexo(idComprometimento, comprometimentoAnexoId) {
        return axiosJwt
            .get(
                `${api}/gescon/financeiro/pagamentos/comprometimentos/${idComprometimento}/anexos/${comprometimentoAnexoId}`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterCertidoes(pagamentoId) {
        return axiosJwt
            .get(
                `${api}/gescon/financeiro/pagamentos/${pagamentoId}/certidoes`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAnexos(pagamentoId) {
        return axiosJwt
            .get(
                `${api}/gescon/financeiro/pagamentos/${pagamentoId}/anexos`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAnexosTipos() {
        return axiosJwt
            .get(`${api}/gescon/financeiro/pagamentos/anexos/tipos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirPagamentoAnexo(pagamentoAnexo) {
        const formData = new FormData()
        formData.append('pagamentoId', pagamentoAnexo.pagamentoId)
        formData.append('tipoId', pagamentoAnexo.tipoId)
        formData.append('descritivo', pagamentoAnexo.descritivo)
        formData.append('arquivo', pagamentoAnexo.arquivo)
        formData.append('numeroDocumento', pagamentoAnexo.numeroDocumento)

        return axiosJwt
            .post(
                `${api}/gescon/financeiro/pagamentos/${pagamentoAnexo.pagamentoId}/anexos`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirAnexo(pagamentoAnexo) {
        return axiosJwt
            .put(
                `${api}/gescon/financeiro/pagamentos/${pagamentoAnexo.pagamentoId}/anexos`,
                pagamentoAnexo
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    exportar(pagamentoId) {
        return axiosJwt
            .get(
                `${api}/gescon/financeiro/pagamentos/${pagamentoId}/exportar`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTimeLine(pagamentoId) {
        return axiosJwt
            .get(`${api}/gescon/financeiro/pagamentos/${pagamentoId}/timeline`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    obterTimeLineComprometimento(comprometimentoId) {
        return axiosJwt
            .get(`${api}/gescon/financeiro/pagamentos/comprometimentos/${comprometimentoId}/timeline`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    obterHistorico(comprometimentoId) {
        return axiosJwt
            .get(`${api}/gescon/financeiro/pagamentos/comprometimentos/${comprometimentoId}/historico`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    obterCategoriasReprovacao() {
        return axiosJwt
            .get(`${api}/gescon/financeiro/pagamentos/reprovarpagamentoopcoes`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    faturarPagamento(processamento) {
        return axiosJwt
            .post(`${api}/gescon/financeiro/pagamentos/faturarpagamento`, processamento)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTiposMovimentoDestino(pagamentoId) {
        return axiosJwt
            .get(
                `${api}/gescon/financeiro/pagamentos/${pagamentoId}/tiposmovimentodestino`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

  
    obterNotasFiscais(pagamentoId) {
        return axiosJwt
            .get(`${api}/gescon/financeiro/pagamentos/${pagamentoId}/notasfiscais`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterNotaFiscal(pagamentoId, pagamentoNotaFiscalId) {
        return axiosJwt
            .get(`${api}/gescon/financeiro/pagamentos/${pagamentoId}/notasfiscais/${pagamentoNotaFiscalId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    downloadNotaFiscal(pagamentoId, pagamentoNotaFiscalId) {
        return axiosJwt
            .get(`${api}/gescon/financeiro/pagamentos/${pagamentoId}/notasfiscais/${pagamentoNotaFiscalId}/download`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    

    atualizarNotaFiscal(pagamentoId, pagamentoNotaFiscalId, notaFiscal) {
        let dataEmissao = notaFiscal.dataEmissao
        if (typeof dataEmissao === 'string' && dataEmissao.includes('/')) {
            const parts = dataEmissao.split('/')
            if (parts.length === 3) {
                dataEmissao = `${parts[2]}-${parts[1].padStart(2, '0')}-${parts[0].padStart(2, '0')}`
            }
        }

        const notaFiscalDto = {
            id: pagamentoNotaFiscalId,
            pagamentoId: pagamentoId,
            tipo: notaFiscal.tipo,
            numeroNota: notaFiscal.numeroNota,
            dataEmissao: dataEmissao,
            mesCompetencia: notaFiscal.mesCompetencia,
            localPrestacao: notaFiscal.localPrestacao,
            servicoPorSocio: notaFiscal.servicoPorSocio,

            prestadorCnpjCpf: notaFiscal.prestadorCnpjCpf,
            prestadorRazaoSocial: notaFiscal.prestadorRazaoSocial,
            prestadorEmail: notaFiscal.prestadorEmail,
            prestadorOptanteSimples: notaFiscal.prestadorOptanteSimples,

            tomadorCnpjCpf: notaFiscal.tomadorCnpjCpf,
            tomadorRazaoSocial: notaFiscal.tomadorRazaoSocial,
            tomadorEmail: notaFiscal.tomadorEmail,

            // Valores
            valorNota: notaFiscal.valorNota,
            valorServico: notaFiscal.valorServico,
            valorDeducao: notaFiscal.valorDeducao,
            deducaoIss: notaFiscal.deducaoIss,
            deducaoInss: notaFiscal.deducaoInss,
            valorIss: notaFiscal.valorIss,
            valorPis: notaFiscal.valorPis,
            valorCofins: notaFiscal.valorCofins,
            valorInss: notaFiscal.valorInss,
            valorIr: notaFiscal.valorIr,
            valorCsll: notaFiscal.valorCsll,
            valorIbs: notaFiscal.valorIbs,
            valorCbs: notaFiscal.valorCbs,

            // Alíquotas
            aliquotaIss: notaFiscal.aliquotaIss,
            aliquotaPis: notaFiscal.aliquotaPis,
            aliquotaCofins: notaFiscal.aliquotaCofins,
            aliquotaInss: notaFiscal.aliquotaInss,
            aliquotaIr: notaFiscal.aliquotaIr,
            aliquotaCsll: notaFiscal.aliquotaCsll,
            aliquotaIbs: notaFiscal.aliquotaIbs,
            aliquotaCbs: notaFiscal.aliquotaCbs,

            // Serviços
            codigoAtividade: notaFiscal.codigoAtividade,
            descricaoAtividade: notaFiscal.descricaoAtividade,
            cosServico: notaFiscal.cosServico,
            descricaoServico: notaFiscal.descricaoServico,
            descricaoNota: notaFiscal.descricaoNota
        }

        return axiosJwt
            .put(
                `${api}/gescon/financeiro/pagamentos/${pagamentoId}/notasfiscais/${pagamentoNotaFiscalId}`,
                notaFiscalDto
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterMunicipios(uf = 'PE') {
        return axiosJwt
            .get(`${api}/gescon/financeiro/pagamentos/municipios/${uf}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }

}
